module.exports = __webpack_public_path__ + "static/media/deleteOrderIcon.3d47ba32.svg";